import {confirmAlert,} from "react-confirm-alert";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import React, {useState} from "react";
import Button from "../../components/UI/Button";
import {deleteUser} from "../../api/user";
import {checkPermission} from "../../util/auth";

const UserFormTableAction = ({row, editRecord}) =>{

  const [toastId, setToastId] = useState(null);

  const queryClient = useQueryClient()

  const {mutate, isPending} = useMutation({
    mutationFn:(data)=> deleteUser(data),
    onMutate: () => {
      setToastId(toast.loading("Please wait..."))
    },
    onSuccess: (response, payload) => {
      toast.update(toastId, { render: "User Deleted!", type: "success", isLoading: false, autoClose: true  });
      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey[0] === 'users',
      });
    },
    onError: () => {
      toast.update(toastId, { render: "Something happened!", type: "error", isLoading: false, autoClose: true });
    }
  })

  const editHandler = ()=>{
    editRecord(row)
  }

  const deleteHandler = () => {
    confirmAlert({
      title: 'Delete',
      message: 'Are you sure to do this.',
      buttons: [
        {
          label: 'Yes',
          className: 'btn',
          onClick: () => {
            mutate({id: row.id})
          },
        },
        {
          label: 'No',
          onClick: () => {
            return;
          },
        }
      ]
    });
  }
  return (
    <>
      {checkPermission(['USER_UPDATE']) &&
      <Button
          text="Edit"
          classes={"mr_5"}
          variant={"btn_transparent has_border_radius"}
          size={'btn_sm'}
          onClickHandler={editHandler}
      />
       }
      {checkPermission(['USER_DELETE']) &&
      <Button
          text="Delete"
          variant={"btn_danger has_border_radius"}
          isPending={isPending}
          size={'btn_sm'}
          onClickHandler={deleteHandler}
      />
      }
    </>
  );
}

export default UserFormTableAction;